import { IRootState } from "app/model"
import { MessageCenter } from "message/components/MessageCenter"
import { IPage } from "page/model"
import React from "react"
import { connect } from "react-redux"
import { Routes as ReactRouterRoutes, Route } from "react-router-dom"
import { LoginPage } from "user/components/LoginPage"
import { FlexBox } from "../FlexBox"

interface INotLogguedRoutesProps {
  pages: IPage[]
  permissions: string[]
}

export const NotLogguedRoutesFn = React.memo(({ pages }: INotLogguedRoutesProps) => (
  <FlexBox
    sx={{ width: "100%", minWidth: "100%", maxWidth: "100%", height: "100%", minHeight: "100%", maxHeight: "100%" }}>
    <ReactRouterRoutes>
      {pages
        .filter(p => p.notLogguedAvailability)
        .map(page => (
          <Route path={page.path} key={page.path} element={<page.jsxElement />} />
        ))}
      <Route path="*" element={<LoginPage />} />
    </ReactRouterRoutes>
    <MessageCenter />
  </FlexBox>
))

export const NotLogguedRoutes = connect(
  (state: IRootState): INotLogguedRoutesProps => ({
    pages: state.page.pages,
    permissions: state.user.permissions
  })
)(NotLogguedRoutesFn)
